var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"image",attrs:{"src":_vm.bgImg,"alt":""},on:{"click":_vm.handleClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }